import tagManagerDataLayerEventNamesLib from 'src/lib/helpers/tagManagerDataLayerEventNames';

export default {
  ...tagManagerDataLayerEventNamesLib,
  MAIN_CTA_BUTTON_CLICK: 'MAIN_CTA_BUTTON_CLICK',
  NAV_BURGER_BUTTON_CLICK: 'NAV_BURGER_BUTTON_CLICK',
  TELEPHONE_CTA_CLICK: 'TELEPHONE_CTA_CLICK',
};
